var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_683_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.3C4.32016 1.3 1.3335 4.28667 1.3335 7.96667C1.3335 11.6467 4.32016 14.6333 8.00016 14.6333H11.3335V13.3H8.00016C5.10683 13.3 2.66683 10.86 2.66683 7.96667C2.66683 5.07334 5.10683 2.63334 8.00016 2.63334C10.8935 2.63334 13.3335 5.07334 13.3335 7.96667V8.92C13.3335 9.44667 12.8602 9.96667 12.3335 9.96667C11.8068 9.96667 11.3335 9.44667 11.3335 8.92V7.96667C11.3335 6.12667 9.84016 4.63334 8.00016 4.63334C6.16016 4.63334 4.66683 6.12667 4.66683 7.96667C4.66683 9.80667 6.16016 11.3 8.00016 11.3C8.92016 11.3 9.76016 10.9267 10.3602 10.32C10.7935 10.9133 11.5402 11.3 12.3335 11.3C13.6468 11.3 14.6668 10.2333 14.6668 8.92V7.96667C14.6668 4.28667 11.6802 1.3 8.00016 1.3ZM8.00016 9.96667C6.8935 9.96667 6.00016 9.07334 6.00016 7.96667C6.00016 6.86 6.8935 5.96667 8.00016 5.96667C9.10683 5.96667 10.0002 6.86 10.0002 7.96667C10.0002 9.07334 9.10683 9.96667 8.00016 9.96667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_683_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAt);
export default __webpack_public_path__ + "static/media/emailAt.a1ac7c3e5f6a7587fa4aa8f1e7ee0484.svg";
export { ForwardRef as ReactComponent };